6<template>
  <div>
    <div class>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="角色id" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input
            placeholder="保存时系统自动生成"
            v-decorator="[
          'id',
          {rules: [{ required: false}],initialValue:info.id}
        ]"
            readonly
          ></a-input>
        </a-form-item>
        <a-form-item label="角色名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input
            placeholder="请输入角色名称"
            :disabled="info.systemLevel == 99"
            v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入角色名称!' }],initialValue:info.name}
        ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="角色说明" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-textarea
            placeholder="请输入角色说明"
            :rows="4"
            v-decorator="[
          'description',
          {rules: [{ required: false, message: '请输入角色说明!' }],initialValue:info.description}
        ]"
          ></a-textarea>
        </a-form-item>
        <a-form-item label="权限设置" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <span class="setBtn" @click="handleRoleSet">设置</span>
        </a-form-item>
        <a-form-item label="后台管理角色" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-switch
            v-model="info.admin"
            v-decorator="[
          'admin',
          {rules: []}
        ]"
          />
        </a-form-item>
        <a-form-item label="角色状态" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-switch
            v-model="info.status"
            v-decorator="[
          'status',
          {rules: []}
        ]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
          <pxkeji-btn name="确认" type="primary" htmlType="submit" />
          <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
        </a-form-item>
      </a-form>
    </div>
    <!---所有的权限-->
    <a-modal title="查看权限" v-model="role.visible" :footer="false" destroyOnClose width="900px">
      <allRole @callbackMethod="save" :checkAuth="info.authorize" />
    </a-modal>
  </div>
</template>

<script>
var that;
import allRole from "./allRole.vue";
export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      dis: this.disabled,
      info: {
        isdisplay: false,
        roleStatus: false,
        authorize: [],
        admin: true,
        status: true
      },
      role: {
        visible: false
      },
      allRemoteTypelist: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      that = this;
      if (this.infos.id) {
        this.getInfo();
      }
    });
  },
  components: {
    allRole
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    sumbit() {
      this.$emit("callbackMethod");
    },
    getInfo() {
      that.isloading = true;
      that.$api.role
        .getById(this.infos.id)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.info = this.infos;
            that.info.status = this.$commen.changeIntBoolean(this.infos.status);
            that.info.admin = this.$commen.changeIntBoolean(this.infos.admin);
            that.info.authorize = res.data.authorize
              ? res.data.authorize.split(",")
              : [];
              // console.log(that.info);
          } else {
            that.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**角色设置 */
    handleRoleSet() {
      this.role.visible = true;
    },
    save(roleList) {
      this.role.visible = false;
      this.info.authorize = roleList;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
           // console.log("提交", values);
           // console.log("提交", that.info.authorize);
          // return false;
          if (this.infos.id) {
            this.isloading = true;
            // console.log(this.infos.id)
            this.$api.role
              .update(
                this.infos.id,
                values.name,
                values.description ? values.description : "",
                that.info.authorize.join(","),
                values.status
                  ? this.$commen.changeBooleanInt(values.status)
                  : this.$commen.changeBooleanInt(this.info.status),
                values.admin
                  ? this.$commen.changeBooleanInt(values.admin)
                  : this.$commen.changeBooleanInt(this.info.admin)
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            this.isloading = true;
            this.$api.role
              .save(
                values.name,
                values.description ? values.description : "",
                that.info.authorize.join(","),
                values.status
                  ? this.$commen.changeBooleanInt(values.status)
                  : this.$commen.changeBooleanInt(this.info.status),
                values.admin
                  ? this.$commen.changeBooleanInt(values.admin)
                  : this.$commen.changeBooleanInt(this.info.admin)
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.setBtn {
  cursor: pointer;
  color: #1890ff;
}
</style>